import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { HttpDataService, IResponseWrapper } from "./httpdata.service";
import { environment } from "src/environments/environment";
import { AppraisalDenialReasonDetails, ReportApprovalModel, ReportApprovalStatus } from "src/models/estate/appraisal.model";
import { IValuationHistoryAppraisalDetails } from "src/models/estate/appraisal-details.model";


@Injectable({
    providedIn: "root"
  })

export class AppraisalService {

    constructor(private http: HttpDataService) {}

    public postAppraisalReportApprovalStatus(params: ReportApprovalModel) {
        return this.http.post<{ data: ReportApprovalModel }>(`${environment.apiUrl}/ValueValidation/InsertReportApprovalStatus`, params).pipe(
                    map((payload) => payload.data)
        );
    }

    public postAppraisalExternalReportApprovalStatus(params: ReportApprovalModel) {
        return this.http.post<{ data: ReportApprovalModel }>(`${environment.apiUrl}/ValueValidation/InsertExternalReportApprovalStatus`, params).pipe(
                    map((payload) => payload.data)
        );
    }

    public getAppraisalReportApprovalHistory(reportId: number) {
        return this.http.get<{ data: ReportApprovalStatus[]}>(`${environment.apiUrl}/ValueValidation/GetAppraisalReportApprovalHistory?reportId=${reportId}`);
    }

    public getExternalAppraisalReportApprovalHistory(reportId: number) {
        return this.http.get<{ data: ReportApprovalStatus[]}>(`${environment.apiUrl}/ValueValidation/GetExternalAppraisalReportApprovalHistory?reportId=${reportId}`);
    }
   
    public getAppraisalDenialReasons(includeHistoric: boolean): Observable<AppraisalDenialReasonDetails[]> {
        return  this.http.get<{ data: AppraisalDenialReasonDetails[] }>(`${environment.apiUrl}/ValueValidation/AppraisalDenialReasons?includeHistoric=${includeHistoric}`)
                    .pipe(map((response) => response.data));
    }

        getValuationAppraisalDetails(appraisalId: number): Observable<IValuationHistoryAppraisalDetails> {
            return this.http
                .get<IResponseWrapper<IValuationHistoryAppraisalDetails>>(`${environment.apiUrl}/RealEstates/ValuationAppraisalDetail?appraisalId=${appraisalId}`)
                .pipe(map((response) => response.data));
        }
    
}